import React, { useContext, useEffect, useState } from "react"

import { Button, Table } from "reactstrap"

import { ScenarioContext } from "../../contexts/ScenarioContext"

import MDBModal from "./MDBModal"

import { formatAsMinSecs } from "../../utils"

const ScenarioInfo = () => {

    const { scenario, timers, started, paused, setStarted, setPaused } = useContext(ScenarioContext)

    const [showModal, setShowModal] = useState(!started || paused)
    const startScenario = () => setStarted(true)
    const resumeScenario = () => setPaused(false)

    // Modal's isOpen needs to be a simple bool prop, not a method
    // so we need a a simple bool which is a result of an expression
    // whenever either of these change
    useEffect(() => {
        setShowModal(!started || paused)
    }, [started, paused])

    return (
        <MDBModal
            name="Scenario Info"
            show={showModal}
        >
            <div className="container-fluid">
                <div className="row">
                    <div className="col-6">
                        <h3>Instructor Information</h3>
                        <p>{scenario.info.instructorInformation}</p>
                    </div>
                    <div className="col-6">
                        <h3>Patient Information</h3>
                        <ul>
                            <li><b>Moulage:</b> {scenario.info.patientInformation.moulage}</li>
                            <li><b>Actions:</b> {scenario.info.patientInformation.actions}</li>
                            <li><b>Position:</b> {scenario.info.patientInformation.position}</li>
                            <li>
                                <b>Gender:</b> {scenario.info.patientInformation.gender} &nbsp;
                                <b>Age:</b> {scenario.info.patientInformation.age} &nbsp;
                                <b>Weight:</b> {scenario.info.patientInformation.weight}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <h3>Dispatch Information</h3>
                        <p>{scenario.info.dispatchInfo}</p>
                    </div>
                    <div className="col-6">
                        <h3>Scene Assessment</h3>
                        <p>{scenario.info.sceneAssessment}</p>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <Table size="sm" striped={true}>
                        <thead>
                            <tr>
                                <th>Timer</th>
                                <th>Duration</th>
                                <th>Time Remaining</th>
                                <th>Expired</th>
                            </tr>
                        </thead>
                        <tbody>
                            {timers.map((timer) => (
                                <tr
                                    key={timer.id}
                                    className="h4"
                                >
                                    <td>{timer.id}</td>
                                    <td>{formatAsMinSecs(timer.duration)}</td>
                                    <td>{formatAsMinSecs(timer.timeRemaining)}</td>
                                    <td>{`${timer.expired}`}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                <div className="row justify-content-md-center">
                    {!started
                        ? <Button color="success" size="lg" onClick={startScenario}> Start Scenario</Button>
                        : <Button color="success" size="lg" onClick={resumeScenario}> Resume Scenario </Button>
                    }
                </div>
            </div>
        </MDBModal>
    )
}

export default ScenarioInfo